import { Heading, HeadingProps } from "@chakra-ui/react";
import React from "react";

export function CardHeading({ children, ...props }: HeadingProps) {
  return (
    <Heading fontSize="3xl" {...props}>
      {children}
    </Heading>
  );
}
